<template>
  <div :style="{borderRadius: radius + 'px', lineHeight: '1px'}" class="imageStyle">
    <van-image :class="gray" id="gray"
               lazy-load
               show-loading
               :width="img_width"
               :height="img_width"
               :fit="fit"
               :src="img_url"
               :radius="radius"
               :round="true"
               :style="{height: heightPx}"
               @click="$emit('click')"
    >
      <template v-slot:loading>
        <van-loading type="spinner" size="20"/>
      </template>
    </van-image>
  </div>
</template>

<script>

export default {
  name: 'Wp_image',

  props: {
    url: {
      type: String,
      default: '',//'/images/default_sku_img.png'
    },
    width: {
      type: String,
      default: '100'
    },
    srcType: { type: String, default: '' },//src类型，为base64时，则获取img的base64添加到src中
    radius: { default: 5 },
    round: { type: Boolean, default: false },
    heightPx: { type: String, default: '' },
    imgGray: { type: Boolean, default: false },
    fit: { type: String, default: 'fill' }
  },

  data () {
    return {
      img_url: '',
      img_width: 0,

      gray: '',
    }
  },
  created () {
    this.initImgUrl()
  },

  watch: {
    url () {
      this.initImgUrl()
    }
  },

  methods: {
    initImgUrl () {
      if (this.url) {

        if (this.srcType && this.srcType === 'base64') {
          //必须使用base64数据的特殊情况
          this.getURLBase64(this.url).then(base64 => {
            this.img_url = base64
          })
        } else {
          let userAgent = navigator.userAgent
          if (userAgent && userAgent.indexOf('Android') > -1 && userAgent.indexOf('MQQBrowser') === -1) {
            //如果是安卓设备，并且是内置浏览器，则img标签使用图片的base64数据（因为内置浏览器可能有广告过滤功能）
            this.getURLBase64(this.url).then(base64 => {
              this.img_url = base64
            })
          } else {
            this.img_url = this.url
          }
        }
      }

      this.gray = ''
      if (this.imgGray) {
        this.gray = 'gray'
      }

      this.img_width = this.width + '%'
      if (this.width.indexOf('px') !== -1) {
        this.img_width = this.width
      }
    },

    getURLBase64 (url) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest()
        xhr.open('get', url, true)
        xhr.responseType = 'blob'
        xhr.onload = function () {
          if (this.status === 200) {
            let blob = this.response
            let fileReader = new FileReader()
            fileReader.onloadend = function (e) {
              let result = e.target.result
              resolve(result)
            }
            fileReader.readAsDataURL(blob)
          }
        }
        xhr.onerror = function () {
          reject()
        }
        xhr.send()
      })
    },
  }
}
</script>

<style scoped>
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  /*-ms-filter: grayscale(100%);*/
  -o-filter: grayscale(100%);

  filter: grayscale(100%);

  filter: 'gray';
}

.imageStyle {
}
</style>